export default __webpack_public_path__ + "static/media/maa.d781e0fd.svg";